import { render, staticRenderFns } from "./PdvDeliveryData.vue?vue&type=template&id=295ce486&scoped=true"
import script from "./PdvDeliveryData.vue?vue&type=script&lang=js"
export * from "./PdvDeliveryData.vue?vue&type=script&lang=js"
import style0 from "./PdvDeliveryData.vue?vue&type=style&index=0&id=295ce486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ce486",
  null
  
)

export default component.exports